import * as Muicon from '@mui/icons-material';
import { SxProps } from '@mui/system';

interface IconProps {
  icon: keyof typeof Muicon;
  sx?: SxProps;
}

export default function Icon({ icon, sx }: IconProps) {
  const Icon = Muicon[icon];
  return Icon && <Icon sx={sx} />;
}
